<template>
    <div class="fill-height">
        <v-container v-if="loading_purchases||client_loading||error_loading" fluid class="fill-height">
            <v-row justify="center" align="center">
                <v-col cols="12" class="text-center">
                    <div v-if="error_loading" class="display-1" style="color: gray">
                        Не удалось загрузить закупки...
                    </div>
                    <v-progress-circular
                        v-else
                        indeterminate
                        size="90"
                        width="3"
                        color="dark">
                    </v-progress-circular>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-else fluid>

            <template v-if="!products_loading&&products.length !== 0&&!has_perm('set_order_state')">
                <v-row justify="center" align="center">
                    <v-col class="font-weight-medium headline pb-0 pt-10" cols="12" sm="9" md="7" lg="6" xl="5">
                        <v-row justify="space-between" align="center" no-gutters>
                            <v-col cols="auto">Новинки</v-col>
                            <v-col cols="auto">
                                <router-link class="text-decoration-none font-weight-regular" :to="{name: 'catalog'}">
                                    <v-row no-gutters justify="end" align="center" class="mr-n2">
                                        <v-col class="primary--text" cols="auto" style="font-size: 14px">
                                            Каталог
                                        </v-col>
                                        <v-col cols="auto">
                                            <v-icon color="primary">{{ iconRight }}</v-icon>
                                        </v-col>
                                    </v-row>
                                </router-link>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row justify="center" align="center" class="mb-n8">
                    <v-col cols="12" sm="9" md="7" lg="6" xl="5">
                        <ProductList :products="products" row>
                            <template #default="{product}">
                                <product-card :product="product" dense/>
                            </template>
                        </ProductList>
                    </v-col>
                </v-row>
            </template>

            <v-row justify="center" align="center">
                <v-col class="font-weight-medium headline pb-0 pt-10" cols="12" sm="9" md="7" lg="6" xl="5">
                    Закупки
                </v-col>
            </v-row>


            <div v-if="has_perm('add_purchase')">
                <div v-if="start_add">
                    <v-row justify="center" align="center">
                        <v-col class="pb-1" cols="12" sm="9" md="7" lg="6" xl="5">
                            <v-form v-model="valid">
                                <v-text-field :rules="rules.title" v-model="purchase.title" :loading="add_loading"
                                              clearable
                                              label="Название для закупки"
                                              hint="Введите название для своей закупки"></v-text-field>
                                <v-textarea v-model="purchase.info" rows="2"
                                            :loading="add_loading"
                                            label="Дополнительная информация"
                                            hint="Любой комментарий (какие-то новости и т.п.)"></v-textarea>
                                <v-datetime-picker
                                    :loading="add_loading"
                                    label="Дата начала закупки"
                                    date-format="dd.MM.yyyy"
                                    clear-text="Очистить"
                                    ok-text="Готово"
                                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                                    :text-field-props="{rules: rules.required}"
                                    v-model="purchase.buyout_date_start">
                                    <template slot="dateIcon">
                                        <v-icon>{{ icon_calendar }}</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>{{ icon_clock }}</v-icon>
                                    </template>
                                </v-datetime-picker>
                                <v-datetime-picker
                                    :loading="add_loading"
                                    label="Дата окончания закупки"
                                    date-format="dd.MM.yyyy"
                                    clear-text="Очистить"
                                    ok-text="Готово"
                                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                                    :text-field-props="{rules: rules.required}"
                                    v-model="purchase.buyout_date_end">
                                    <template slot="dateIcon">
                                        <v-icon>{{ icon_calendar }}</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>{{ icon_clock }}</v-icon>
                                    </template>
                                </v-datetime-picker>
                                <v-datetime-picker
                                    :loading="add_loading"
                                    label="Дата начала добавления заказов"
                                    date-format="dd.MM.yyyy"
                                    clear-text="Очистить"
                                    ok-text="Готово"
                                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                                    :text-field-props="{rules: rules.required}"
                                    v-model="purchase.load_date_start">
                                    <template slot="dateIcon">
                                        <v-icon>{{ icon_calendar }}</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>{{ icon_clock }}</v-icon>
                                    </template>
                                </v-datetime-picker>
                                <v-datetime-picker
                                    :loading="add_loading"
                                    label="Дата окончания добавления заказов"
                                    date-format="dd.MM.yyyy"
                                    clear-text="Очистить"
                                    ok-text="Готово"
                                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                                    :text-field-props="{rules: rules.required}"
                                    v-model="purchase.load_date_end">
                                    <template slot="dateIcon">
                                        <v-icon>{{ icon_calendar }}</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>{{ icon_clock }}</v-icon>
                                    </template>
                                </v-datetime-picker>
                                <v-datetime-picker
                                    :loading="add_loading"
                                    label="Дата окончания оплаты заказов"
                                    date-format="dd.MM.yyyy"
                                    clear-text="Очистить"
                                    ok-text="Готово"
                                    :date-picker-props="{locale: 'ru-ru', firstDayOfWeek: 1}"
                                    :time-picker-props="{locale: 'ru-ru', format: '24hr'}"
                                    :text-field-props="{rules: rules.required}"
                                    v-model="purchase.pay_date_end">
                                    <template slot="dateIcon">
                                        <v-icon>{{ icon_calendar }}</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>{{ icon_clock }}</v-icon>
                                    </template>
                                </v-datetime-picker>
                                <v-alert border="left" type="info" outlined>
                                    Вы можете включить режим дозаказа в созданной закупке, для этого нажмите у неё в
                                    правом верхнем углу <strong>"ТРИ ТОЧКИ"</strong> -> <strong>"ИЗМЕНИТЬ"</strong> -> в
                                    самом низу карточки закупки есть
                                    настройка <strong>Дозаказа</strong>
                                </v-alert>
                                <!--                                <v-switch-->
                                <!--                                        :loading="add_loading"-->
                                <!--                                        v-model="purchase.backorder"-->
                                <!--                                        inset-->
                                <!--                                >-->
                                <!--                                    <template v-slot:label>-->
                                <!--                                        Режим дозаказа (для опытных)-->
                                <!--                                        <v-tooltip top max-width="340">-->
                                <!--                                            <template v-slot:activator="{ on }">-->
                                <!--                                                <v-icon right class="grey&#45;&#45;text" v-on="on">{{icon_help}}</v-icon>-->
                                <!--                                            </template>-->
                                <!--                                            При включенном режиме дозаказа ваши клиенты смогут добавлять заказы во-->
                                <!--                                            время вашей закупки вне зависимости от дат загрузки, но только на места, где-->
                                <!--                                            есть заказы в статусе "Ожидает" (то есть места которые вы ещё не прошли на-->
                                <!--                                            рынке)-->
                                <!--                                        </v-tooltip>-->
                                <!--                                    </template>-->
                                <!--                                </v-switch>-->
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="start">
                        <v-col class="text-right pt-0" cols="12" sm="9" md="7" lg="6" xl="5">
                            <v-btn rounded class="text-none font-weight-regular body-2 seccondary mr-2"
                                   :disabled="add_loading"
                                   @click="start_add=false">Отмена
                            </v-btn>
                            <v-btn rounded :loading="add_loading" :disabled="!valid"
                                   class="text-none font-weight-regular body-2 success"
                                   @click="onAddPurchase">
                                Создать
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <v-row v-else justify="center" align="center">
                    <v-col class="pb-1" cols="12" sm="9" md="7" lg="6" xl="5">
                        <v-btn rounded dark color="green" class="text-none font-weight-regular body-2"
                               @click="start_add=true">
                            Создать новую закупку
                        </v-btn>
                    </v-col>
                </v-row>
            </div>


            <v-row v-if="purchases.length === 0" justify="center" align="center">
                <v-col class="text-center text--secondary py-12" cols="12" sm="9" md="7" lg="6" xl="5">
                    <div v-if="has_perm('add_purchase')">
                        <div class="display-1">У вас нет закупок</div>
                        <div class="subtitle-1">Создайте свою первую закупку что бы начать принимать заказы</div>
                    </div>
                    <div v-else class="display-1">
                        <div class="display-1">Нет доступных закупок</div>
                        <div class="subtitle-1">Попробуйте позже...</div>
                    </div>
                </v-col>
            </v-row>
            <div v-else>
                <infinity-load :next_page="next_page" @loadnext="onLoadNextPurchases">
                    <v-row v-for="(purchase) in purchases" :key="purchase.id" justify="center" align="center">
                        <v-col cols="12" sm="9" md="7" lg="6" xl="5">
                            <purchase :purchase="purchase"/>
                        </v-col>
                    </v-row>
                </infinity-load>
            </div>
        </v-container>

        <recalculation-percent-dialog/>
        <settings-backorder-dialog/>
        <download-purchase-dialog/>

    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { mdiCalendarMonth, mdiChevronRight, mdiClock, mdiHelpCircle } from '@mdi/js';
import DatetimePicker from "../utils/DateTimePicker";
import InfinityLoad from "../utils/InfinityLoad";
import Purchase from "./Purchase";
import RecalculationPercentDialog from "./RecalculationPercentDialog";
import SettingsBackorderDialog from "@/components/purchases/SettingsBackorderDialog";
import ProductList from "@/components/catalog/ProductList.vue";
import ProductCard from "@/components/catalog/ProductCard.vue";
import DownloadPurchaseDialog from "@/components/purchases/DownloadPurchaseDialog.vue";

export default {
    name: "Purchases",
    components: {
        DownloadPurchaseDialog,
        ProductCard,
        ProductList,
        SettingsBackorderDialog,
        RecalculationPercentDialog,
        Purchase,
        InfinityLoad,
        'v-datetime-picker': DatetimePicker
    },
    data() {
        return {
            icon_calendar: mdiCalendarMonth,
            icon_clock: mdiClock,
            icon_help: mdiHelpCircle,
            iconRight: mdiChevronRight,

            add_loading: false,
            error_loading: false,

            start_add: false,
            valid: false,

            purchase: {
                info: '',
                backorder: false,
            },

            rules: {
                title: [
                    value => !!value || 'Обязательно для заполнения',
                    value => (value && value.length >= 2) || 'Минимум 2 символа.',
                ],
                required: [
                    value => !!value || 'Обязательно для заполнения',
                ],
            }
        }
    },
    computed: {
        ...mapState('products', [
            'products',
            'products_loading',
        ]),
        ...mapState('clients', [
            'current_client',
            'client_loading',
        ]),
        ...mapState('shop', [
            'shop'
        ]),
        ...mapState('purchases', [
            'purchases',
            'next_page',
            'loading_purchases'
        ]),
        ...mapGetters('clients', [
            'has_perm',
        ]),
    },
    methods: {
        ...mapActions('products', [
            'getProducts',
        ]),
        ...mapActions('purchases', [
            'addPurchase',
            'getPurchases',
        ]),
        ...mapMutations('purchases', [
            'clearData'
        ]),
        onLoadNextPurchases() {
            this.getPurchases();
        },
        onAddPurchase() {
            this.add_loading = true;
            this.purchase.shop = this.shop.id;
            this.addPurchase(this.purchase)
                .then(() => {
                    this.purchase = {
                        info: '',
                        backorder: false,
                    };
                    this.start_add = false;
                    this.add_loading = false;
                })
                .catch(() => {
                    this.add_loading = false;
                })
        },
    },
    watch: {
        'purchase.backorder': {
            handler: function (val) {
                if (val) {
                    this.$set(this.purchase, 'load_date_start', this.$dateNow().toISOString())
                    this.purchase.load_date_start = this.$dateNow().toISOString();
                    if (this.purchase.load_date_end) {
                        if (Date.parse(this.purchase.load_date_end) < Date.parse(this.purchase.load_date_start)) {
                            let date = new Date()
                            this.purchase.load_date_end = new Date(date.setDate(date.getDate() + 1)).toISOString();
                        }
                    } else {
                        let date = new Date()
                        this.purchase.load_date_end = new Date(date.setDate(date.getDate() + 1)).toISOString();
                    }
                }
            }
        }
    },
    mounted() {
        this.clearData();
        this.getPurchases()
            .catch(() => {
                this.error_loading = true;
            })
        if (!this.has_perm('set_order_state')) {
            this.getProducts()
        }
    }
}
</script>

<style scoped>

</style>